import API from "./api";
import OpenDialog from "./dialog";
import OpenErrorDialog from "./dialog_error";
import { ShowProposalSubmitting, ShowProposalSuccess } from "./snackbar";
import { OpenInNewModalSVG } from "./icons";

const Positives = () => window.map_data["Positive Properties"].map( p => p.Term );

export default class extends HTMLElement {
    #button = null;
    #term = "";

    connectedCallback () {
        this.#term = this.attributes.term.value;
        this.innerHTML = `
            <button>
                <span>Propose new</span>
                ${OpenInNewModalSVG}
            </button>
        `;
        this.#button = this.querySelector("button");

        this.#button.addEventListener("click", async (e) => {
            e.preventDefault();
            this.openDialog();
        });
    }

    openDialog () {
        const selectList = document.createElement("select");
        selectList.required = true;
        selectList.name = "positive";
        selectList.style.borderRadius = "7px";

        const option = document.createElement("option");
        option.value = "";
        option.text = "New positive relation";
        selectList.appendChild(option);

        Positives().forEach(positive => {
            const option = document.createElement("option");
            option.value = positive;
            option.text = positive;
            selectList.appendChild(option);
        });

        const el = document.createElement("div");
        el.innerHTML = `
            <form id="propose-resource-form" method="dialog">
                ${selectList.outerHTML}
                <textarea required placeholder="General reasoning. How is this relationship appropriate?" name="reasoning"></textarea>
                <button type="submit" value="confirm">Propose relationship</button>
            </form>
        `;

        const dialog = OpenDialog("Propose a new positive relationship to this harm", el.innerHTML);

        const handler = async (e) => {
            dialog.removeEventListener("close", handler);
            if (e.target.returnValue !== "confirm") {
                return;
            }
            e.target.returnValue = "";
            const form = e.target.querySelector("form#propose-resource-form");

            const formData = new FormData(form);

            ShowProposalSubmitting();

            const response = await API.proposeHarmRelationshipToPositive(
                this.#term,
                formData.get("positive"),
                formData.get("reasoning"),
            );

            if (response.ok) {
                ShowProposalSuccess();
            } else {
                const errorData = await response.json();
                OpenErrorDialog(errorData);
                return;
            }

            return false;
        };

        dialog.addEventListener("close", handler);
    }
}
